import { Box, BoxProps, ButtonNew, IconButton, Spacer } from '@jfs/ui-new'

const getDownloadDeleteView = (
  itemData: any,
  downloadReportFile: (data: any) => void,
  deleteReportFile: (data: any) => void,
  styles: BoxProps,
) => {
  const onDelete = () => {
    deleteReportFile(itemData)
  }

  const onDownload = () => {
    downloadReportFile(itemData)
  }
  return (
    <Box {...styles} flexDirection={'row'} marginRight={120}>
      <ButtonNew
        textType={'body12'}
        borderWidth={1}
        borderColor={'DISABLED_GREY'}
        borderRadius={4}
        titleColor={'BLACK_21'}
        height={30}
        color={'WHITE'}
        title={'Download'}
        icon={'DOWNLOAD'}
        iconPaddingRight={'6'}
        onPress={onDownload}
        testID={'btn-downloadReportFile'}
        width={90}
        disabled={itemData?.status === 'In Progress' || itemData?.status === 'Failed'}
      />
      <Spacer direction={'horizontal'} size={16} />
      <Box
        borderWidth={1}
        borderColor={'DISABLED_GREY'}
        borderRadius={4}
        height={30}
        alignItems={'center'}
        justifyContent={'center'}>
        <IconButton onPress={onDelete} testID="btn-deleteReportFile" id={'DELETE'} size={14} />
      </Box>
    </Box>
  )
}

export { getDownloadDeleteView }
